import React, { Component } from 'react'
import styled from 'styled-components'
import { Mobile, Desktop } from '../../../media'

import BrokerComparisonTable from './BrokerComparisonTable'
import BrokerComparisonDialog from './BrokerComparisonDialog'
import HowTo from './HowTo';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import employeeService from '../../../services/Employee.service'

const Wrapper = styled.div`
    background-color: #EDEDED; 
    width: 100%;
`

const Container = styled.div`
    width: 930px;
    margin: 0 auto;

    // Mobile version.
    @media (max-width: 768px) {
        width: 100%
    }

    > div {
        padding-top: 24px;
        padding-bottom: 71px;
        height: auto;
        width: 100%;

        // Mobile version.
        @media (max-width: 768px) {
            width: 100%;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            float: none;
            padding-left: 15px;
            padding-right: 15px;
            padding-bottom: 0;
        }
    }

    > div:first-child {
        margin-right: 30px;

        // Mobile version.
        @media (max-width: 768px) {
            margin-right: 0;
        }
    }

    > div.dive-deep {
        padding-top: 25px;
        background-color: #EDEDED;

        > h2 {
            font-family: Lato-Light;
            font-size: 24px;
            font-weight: normal;
            color: #2B2B2B;
            text-align: left;
            line-height: 28px;
            margin-top: 0;
            margin-bottom: 5px;
        }

        > p {
            font-family: Lato-Regular;
            font-size: 14px;
            color: #2B2B2B;
            text-align: left;
            line-height: 22px;
            margin-top: 0;
            margin-bottom: 14px;
        }

        > button {
            width: 100%;
            height: 43px;
            margin-bottom: 22px;
        }
    }

    > div.clear {
        float: none;
        clear: both;
    }
`

class Comparison extends Component {

    constructor(props) {
        super(props);

        this.state = {      
            brokerComparisonDialogVisible: false
        }
    }

    showBrokerComparisonDialog = () => {
        this.setState({
            brokerComparisonDialogVisible: true
        })
    }  

    brokerComparisonOnCloseDialog = () => {
        this.setState({
            brokerComparisonDialogVisible: false
        })
    }  

    render() {
        const {employee} = this.props
        return (
            <Wrapper>
                <Container>
                    <Desktop>
                        <BrokerComparisonTable/>
                    </Desktop>
                    <Mobile>
                        <div className="dive-deep">
                            <h2>Want to dive deep?</h2>
                            <p>See the detailed side-by-side comparison</p>
                            <button className="primary-button" onClick={this.showBrokerComparisonDialog} aria-haspopup="true">Compare brokers</button>
                        </div>
                        { !employeeService.isWholeFoodsEmployee(employee) &&
                            <HowTo/>
                        }
                    </Mobile>
                    <Desktop>
                        <div className="clear"/>
                    </Desktop>
                </Container> 
                <Mobile>
                    <BrokerComparisonDialog
                        visible = {this.state.brokerComparisonDialogVisible}
                        onCloseDialog = {this.brokerComparisonOnCloseDialog}
                    />     
                </Mobile>

            </Wrapper>
        )
    }
}

const mapState = state => ({
    employee: state.employee
 })

 export default connect(mapState)(withTranslation("translations")(Comparison));
